export const MODAL_TYPES = {
  AUDIO_TEST: 'AUDIO_TEST'
};
